import SettingFrame from "../../../../components/@settings/SettingFrame";
import NewInjectionField from "../../../../components/@injection_fields/NewInjectionField";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function InjectionFieldNewPage() {

    let routeType = routeTypes.admin

    return (
        <SettingFrame
            routeType={routeType}
        >
            <NewInjectionField
                routeType={routeType}
            />
        </SettingFrame>
    )
}       